/**
 * FabricComposition fra GetSeason (én streng) → HTML til info-panel.
 * Default: én composition uændret. Split kun ved flere segmenter (label eller komma).
 */
export function formatFabricCompositionForHtml(raw) {
    if (raw == null) {
        return '';
    }
    var text = String(raw).trim();
    if (!text.length) {
        return '';
    }
    var labelParts = text
        .split(/\s+(?=Fabric Composition(?:\s+\d+)?\s*:)/i)
        .map(function (s) {
        return s.trim();
    })
        .filter(function (s) {
        return s.length > 0;
    });
    if (labelParts.length > 1) {
        return labelParts.join('<br/>');
    }
    if (text.indexOf(',') !== -1) {
        var commaParts = text
            .split(',')
            .map(function (s) {
            return s.trim();
        })
            .filter(function (s) {
            return s.length > 0;
        });
        if (commaParts.length > 1) {
            return commaParts.join('<br/>');
        }
    }
    return text;
}
//# sourceMappingURL=formatFabricCompositionForHtml.js.map